import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";

export default function ProtectedRoute({ children, requireOwner = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen w-full flex items-center justify-center"
        style={{ background: "#08080C", color: "#D4AF37" }}
      >
        <div className="font-mono-pl text-[11px] uppercase tracking-[0.32em] animate-pulse">
          Caricamento…
        </div>
      </div>
    );
  }

  if (!user || !user.id) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (requireOwner && user.role !== "owner") {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
